import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
import { SvgIcon, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import { OverflowText } from "../overflow-text/OverflowText.js";
import { ColorDynamic } from "../theme/Color.js";
import { isEmptyReactNode } from "../utils/isEmptyReactNode.js";
import { useUID } from "../utils/useUID.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function sizeVariant(theme, mobileSpacing, desktopSpacing) {
  return {
    '& > $list, & > $item': {
      '&:not(:last-child)': {
        paddingBottom: theme.spacing(mobileSpacing),
        [theme.breakpoints.up('sm')]: {
          paddingBottom: theme.spacing(desktopSpacing)
        }
      }
    }
  };
}
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  list: sizeVariant(theme, 2, 1),
  listSmall: sizeVariant(theme, 1, 0.5),
  listLarge: sizeVariant(theme, 3, 2),
  item: {
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    display: 'inline-flex',
    marginRight: theme.spacing(1),
    '& > .MuiSvgIcon-root': {
      color: ColorDynamic.Dark100,
      fontSize: theme.spacing(3),
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.spacing(2)
      }
    }
  }
}), {
  name: 'SD-DescriptionList'
});

//
// DescriptionList
//

export var DescriptionList = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      size
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var styles = useStyles();
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    "data-size": size,
    className: clsx(styles.list, {
      [styles.listSmall]: size === 'small',
      [styles.listLarge]: size === 'large'
    })
  }));
});

//
// DescriptionListItem
//
if (process.env.NODE_ENV !== "production") DescriptionList.displayName = "DescriptionList";
export var DescriptionListItem = /*#__PURE__*/forwardRef((_ref2, ref) => {
  var _ref3, _contentTypographyPro, _contentTypographyPro2;
  var {
    inset,
    icon = inset ? /*#__PURE__*/_jsx(SvgIcon, {}) : null,
    label,
    labelTypographyProps,
    content,
    contentTypographyProps,
    fallback
  } = _ref2;
  var styles = useStyles();
  var labelID = useUID(labelTypographyProps === null || labelTypographyProps === void 0 ? void 0 : labelTypographyProps.id);
  var shouldRenderFallback = isEmptyReactNode(content);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    className: styles.item,
    "aria-labelledby": label != null ? labelID : undefined,
    children: [!!icon && /*#__PURE__*/_jsx("div", {
      className: styles.icon,
      children: icon
    }), /*#__PURE__*/_jsxs(OverflowText, _objectSpread(_objectSpread({}, contentTypographyProps), {}, {
      component: "span",
      color: shouldRenderFallback && label == null ? 'textSecondary' : 'textPrimary',
      TooltipProps: _objectSpread(_objectSpread({}, contentTypographyProps === null || contentTypographyProps === void 0 ? void 0 : contentTypographyProps.TooltipProps), {}, {
        title: (_ref3 = (_contentTypographyPro = contentTypographyProps === null || contentTypographyProps === void 0 ? void 0 : (_contentTypographyPro2 = contentTypographyProps.TooltipProps) === null || _contentTypographyPro2 === void 0 ? void 0 : _contentTypographyPro2.title) !== null && _contentTypographyPro !== void 0 ? _contentTypographyPro : content) !== null && _ref3 !== void 0 ? _ref3 : undefined
      }),
      children: [label != null && /*#__PURE__*/_jsx(Typography, _objectSpread(_objectSpread({}, labelTypographyProps), {}, {
        id: labelID,
        variant: "body2",
        component: "span",
        color: "textSecondary",
        children: label
      })), label != null && ' ', !shouldRenderFallback ? content : fallback]
    }))]
  });
});
if (process.env.NODE_ENV !== "production") DescriptionListItem.displayName = "DescriptionListItem";